import React, { CSSProperties, useEffect, useState } from 'react';

import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import {
  useGetNotificationsLazyQuery,
  useUpdateNotificationsMutation,
} from '@school_ify/schoolify-repository/src/shared/types';

import { useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';
import DropDown from 'components/DropDown/DropDown';
import Bell from 'components/Icons/Bell';
import useDeviceDetect from 'hooks/useDeviceDetect';

import NotificationDot from './components/NotificationDot';

import './NotificationButton.scoped.scss';

interface Props {
  children?: React.ReactNode;
  boxStyle?: CSSProperties;
}

const NotificationButton: React.FC<Props> = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const user = useAppSelector(getUser);
  const { isMobile } = useDeviceDetect();

  const [getNotifications, { data, refetch }] = useGetNotificationsLazyQuery({
    variables: {
      user_id: user.id,
    },
  });

  useEffect(() => {
    getNotifications();
  }, []);

  const [updateNotificationsMutation] = useUpdateNotificationsMutation();

  const notificationsLength = data?.notifications_aggregate?.aggregate?.count;
  const notificationsToDisplay = data?.notifications?.slice(0, 10);

  const handleBellIconClick = () => {
    setShowMenu(!showMenu);
    if (!showMenu && notificationsLength > 0) {
      const updatedNotifications = data.notifications.map(e => ({
        id: e?.id,
        content: e?.content,
        user_id: e?.user_id,
        is_read: true,
      }));
      updateNotificationsMutation({
        variables: { object: updatedNotifications },
        onCompleted() {
          refetch();
        },
      });
    }
  };

  const BellIcon = () => {
    return (
      <div className="notification-icon-container" onClick={() => handleBellIconClick()}>
        {notificationsLength > 0 && <NotificationDot>{notificationsLength}</NotificationDot>}
        <Bell
          color={`${isMobile ? 'var(--colour-borders)' : 'var(--colour-secondary)'}`}
          fontSize="1.3em"
        />
      </div>
    );
  };

  const handleNotificationClicked = e => {
    const url = new URL(e.path);
    history.push(`${url.pathname + url.search}`);
  };

  return (
    <DropDown
      icon={BellIcon()}
      style={{ width: '40px', height: '40px' }}
      boxStyle={{ width: '150px' }}
    >
      {notificationsToDisplay?.map(e => {
        try {
          const parsedContent = JSON.parse(e.content);
          return (
            <p
              className="notification-dropdown-items pointer"
              key={e.path}
              onClick={() => handleNotificationClicked(e)}
            >
              {t(parsedContent.message, parsedContent.variables)}
            </p>
          );
        } catch (err) {
          console.error(err);
          return null;
        }
      })}
    </DropDown>
  );
};

export default NotificationButton;
